module.exports = __webpack_public_path__ + "static/media/aa60220f-d2d4-4160-a51d-48796467ac75_1.ff7d19eea52923287320df149329dc06.a41a8a4e.jpeg";